export const pt = {
parking:{
    list: {

    },
    page: {
        slotInfo: {
            allCategories: 'Todas',
            category: 'Categoria',
            occupiedSlots: 'Lugares Ocupados',
            parkingSlots: 'Lugares de Estacionamento',
            freeSlots: 'Lugares Livres',
            total: 'Total'
        },
        categoryChange: {
            title: 'Alterar categoria do Lugar %{slotName}',
            category: {
                label: 'Categoria',
                placeholder: 'Escolha uma categoria'
            },
            success: {
                title: "Categoria Alterada",
                text: "Categoria do lugar de estacionamento alterada com sucesso"
            },
            error: 'Não foi posssível alterar a categoria',
            submit: 'Guardar'
        },
        graph: {
            numberOfSlots: '% de lugares'
        }
    },
    table: {
        name: 'Nome do Lugar',
        slot: 'Lugar',
        parkingFloor: 'Andar',
        status: 'Estado',
        timestamp: 'Última Atualização',
        category: 'Categoria'
    },
    categories: {
        regular: "Regular",
        mobility: "Mobilidade",
        noCategory: "N/A"
    },
    status: {
        free: "Livre",
        occupied: "Ocupado",
        busy: "Ocupado",
        occupiedAvg: "Média de Ocupação"
    },
    search: {
        placeholders: {
            slot: 'Escolher lugares',
            name: 'Inserir nome',
            parkingFloor: 'Escolher andares',
            status: 'Escolher estado',
            category: 'Escolher categorias',
            startTime: 'Escolher uma data de início',
            endTime: 'Escolher uma data de fim',
            startWorkingHours: 'Escolher a hora de início',
            endWorkingHours: 'Escolher a hora de fim',
        },
        labels: {
            startTime: 'Data de Início',
            endTime: 'Data de Fim',
            startWorkingHours: 'Horas de Início do Dia',
            endWorkingHours: 'Horas do Fim do Dia'
        },
        fields: {
            parking: {
                label: 'Parque',
                placeholder: 'Selecionar parque'
            },
            floor: {
                label: 'Andar',
                placeholder: 'Selecionar andar'
            },
            status: {
                label: 'Estado',
                placeholder: 'Selecionar estado'
            }
        }
    }
},
};